import React from 'react'
import {BaseIcon, type IconProps} from './icon-base'

export const InstagramIcon: React.FC<IconProps> = (props) => (
    <BaseIcon {...props}>
        <rect width="20" height="20" x="2" y="2" rx="5" ry="5" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.5 6.5h.01" />
    </BaseIcon>
)

export const FacebookIcon: React.FC<IconProps> = (props) => (
    <BaseIcon {...props}>
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
    </BaseIcon>
)
